import React from "react";
import StatusBadge from "../../ui/StatusBadge";

export default function KpiBadge({ value }) {
  const key = (value || "unknown").toLowerCase();
  const label = key.charAt(0).toUpperCase() + key.slice(1);

  return <StatusBadge variant="kpi" value={key} label={label} data-testid="kpi-badge" />;
}
